import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';

export const locationSetupRoutes: Routes = [
  {
    path: 'location-setup',
    loadComponent: () =>
      import('@feature/setting/location-setup/location-setup.component').then(
        m => m.LocationSetupComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'regions',
      },
      {
        path: 'regions',
        canActivate: [permissionGuard('DispatcherRegionsAndLocationsView')],
        loadComponent: () =>
          import('./regions/regions.component').then(m => m.RegionsComponent),
      },
      {
        path: 'locations',
        canActivate: [permissionGuard('DispatcherLocationsView')],
        loadComponent: () =>
          import('./locations/locations.component').then(
            m => m.LocationsComponent
          ),
      },
      {
        path: 'kiosks',
        canActivate: [permissionGuard('DispatcherLocationKiosksView')],
        loadComponent: () =>
          import('./kiosks/kiosks.component').then(m => m.KiosksComponent),
      },
      {
        path: 'inspection-times',
        canActivate: [permissionGuard('DispatcherLocationKiosksView')],
        loadComponent: () =>
          import('@feature/setting/location-setup/inspection-times/inspection-times.component').then(
            m => m.InspectionTimesComponent
          ),
      },
    ],
  },
];
